import { render, staticRenderFns } from "./dummy-popup.vue?vue&type=template&id=c3e491dc&scoped=true&"
import script from "./dummy-popup.vue?vue&type=script&lang=ts&"
export * from "./dummy-popup.vue?vue&type=script&lang=ts&"
import style0 from "./dummy-popup.vue?vue&type=style&index=0&id=c3e491dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e491dc",
  null
  
)

export default component.exports